export default "__VITE_ASSET__3d411ccf__$_?nuxt_component=async__"